{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXPDFThumbnailList;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCTypes, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCCustomScrollControl,
  WEBLib.Controls, WEBLib.TMSFNCCustomList, WEBLib.TMSFNCWXPDFViewer
  {$IFNDEF LCLWEBLIB}
  ,UITypes, Generics.Collections, Types
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  //version history
  //v1.0.0.0: First Release

type
  TTMSFNCWXCustomThumbnailList = class;

  TTMSFNCWXThumbnailListItem = class(TTMSFNCCustomListItem)
  private
    FBitmap: TTMSFNCBitmap;
  public
    destructor Destroy; override;
    property Text;
    property CanSelect;
    property CanDeselect;
    property HorizontalTextAlign;
    property VerticalTextAlign;
    property Bitmap: TTMSFNCBitmap read FBitmap write FBitmap;
  end;

  TTMSFNCWXThumbnailListItems = class(TTMSFNCCustomListItems)
  protected
    function CreateItemClass: TCollectionItemClass; override;
  end;

  TTMSFNCWXCustomThumbnailList = class(TTMSFNCCustomList)
  private
    FNumPages: Integer;
    FOldCalculate: Boolean;
    FOldNotification: TTMSFNCWXPDFViewerGenerateThumbnail;
    FOldLoaded: TTMSFNCWXPDFViewerLoaded;
    FOldShowPage: TTMSFNCWXPDFViewerNavigatePageEvent;
    FOldThumbsProgress: TTMSFNCWXPDFViewerThumbnailProgressEvent;
    FViewer: TTMSFNCWXPDFViewer;
    procedure SetViewer(const Value: TTMSFNCWXPDFViewer);
  protected
    function GetDocURL: string; override;
    function GetVersion: String; override;
    function CreateItemsCollection: TTMSFNCCustomListItems; override;
    function GetTotalContentHeight: Double; override;
    function GetTotalContentWidth: Double; override;
    procedure DoItemDrawContent(AGraphics: TTMSFNCGraphics; ARecT: TRectF; AItem: TTMSFNCCustomListItem); override;
    procedure DoBeforeDraw(AGraphics: TTMSFNCGraphics; ARect: TRectF; var ADefaultDraw: Boolean); override;
    procedure DoItemSelected(AItemIndex: Integer); override;
    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
    procedure DoGenerateThumbnail(Sender: TObject; NumPage: Integer; Base64Img: string);
    procedure DoPDFLoaded(Sender: TObject; NumPages: Integer);
    procedure DoPDFNavigatePage(Sender: TObject; APageNumber: Integer);
    procedure DoThumbnailProgress(Sender: TObject; APosition, ASize: Integer);
    property Viewer: TTMSFNCWXPDFViewer read FViewer write SetViewer;
  public
    constructor Create(AOwner: TComponent); override;
    procedure Rebuild; override;
    procedure InitializeDefault; override;
    property Items;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCWXPDFThumbnailList = class(TTMSFNCWXCustomThumbnailList)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property AntiAliasing;
    property Appearance;
    property Viewer;
    property Orientation default toVertical;
    property Version: string read GetVersion;
    property OnItemSelected;
    property OnItemClick;
    property OnItemBeforeDrawBackground;
    property OnItemAfterDrawBackground;
    property OnItemBeforeDrawContent;
    property OnItemAfterDrawContent;
    property OnBeforeDraw;
    property OnAfterDraw;
    property OnItemBeforeDrawText;
    property OnItemAfterDrawText;
  end;

implementation

uses
  SysUtils, WEBLib.Graphics, Math, WEBLib.Forms, WEBLib.TMSFNCUtils, WEBLib.TMSFNCStyles;

{$R 'TMSFNCWXPDFThumbnailList.res'}

type
  TTMSFNCWXPDFViewerOpen = class(TTMSFNCWXPDFViewer);

{ TTMSFNCWXCustomThumbnailList }

constructor TTMSFNCWXCustomThumbnailList.Create(AOwner: TComponent);
var
  I: Integer;
begin
  inherited;
  {$IFNDEF WEBLIB}
  NativeCanvas := True;
  AntiAliasing := True;
  {$ENDIF}
  TouchScrolling := True;
  Orientation := toVertical;
  Appearance.TextFormat := 'Page %d';
  FNumPages := 0;

  Width := 200;
  Height := 500;

  if Assigned(AOwner) and (AOwner is TCustomForm) then
  begin
    for I := 0 to AOwner.ComponentCount - 1 do
    begin
      if (AOwner.Components[i] is TTMSFNCWXPDFViewer) then
      begin
        Viewer := AOwner.Components[i] as TTMSFNCWXPDFViewer;
        Break;
      end;
    end;
  end;

  InitializeDefault;
end;

procedure TTMSFNCWXCustomThumbnailList.InitializeDefault;
begin
  if Assigned(Viewer) then
  begin
    FNumPages := Viewer.PageCount;
    Rebuild;
    Viewer.GenerateThumbnails;
  end
  else
    Rebuild;
end;

procedure TTMSFNCWXCustomThumbnailList.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  inherited;
  if (Operation = opRemove) and (AComponent = Viewer) then
    FViewer := nil;
end;

function TTMSFNCWXCustomThumbnailList.CreateItemsCollection: TTMSFNCCustomListItems;
begin
  Result := TTMSFNCWXThumbnailListItems.Create(Self);
end;

procedure TTMSFNCWXCustomThumbnailList.DoBeforeDraw(AGraphics: TTMSFNCGraphics;
  ARect: TRectF; var ADefaultDraw: Boolean);
{$IFNDEF WEBLIB}
var
  r, rc: TRectF;
  bmp: TTMSFNCBitmap;
  s: string;
{$ENDIF}
begin
  {$IFNDEF WEBLIB}
  if csDesigning in ComponentState then
  begin
    r := ARect;
    InflateRectEx(r, -(r.Right - r.Left) / 5, -(r.Bottom - r.Top) / 5);
    s := 'Please connect an instance of TTMSFNCWXPDFViewer to visualize all thumbnails at runtime';
    AGraphics.Font.Height := ScalePaintValue(-11);
    rc := AGraphics.CalculateText(s, r, True);
    AGraphics.DrawText(r, s, True, gtaCenter, gtaCenter);
    if Assigned(Viewer) then
      s := 'TMSFNCWXPDFTHUMBNAILLISTACCEPT'
    else
      s := 'TMSFNCWXPDFTHUMBNAILLISTLINK';

    bmp := TTMSFNCBitmap.CreateFromResource(s, HInstance);
    try
      AGraphics.DrawBitmap(r.Left + ((r.Right - r.Left) - bmp.Width) / 2, r.Top + ((r.Bottom - r.Top) - (rc.Bottom - rc.Top)) / 2 + (rc.Bottom - rc.Top) + 10, r.Left + ((r.Right - r.Left) - bmp.Width) / 2 + bmp.Width,
        r.Top + ((r.Bottom - r.Top) - (rc.Bottom - rc.Top)) / 2 + (rc.Bottom - rc.Top) + 10 + bmp.Height, bmp);
    finally
      bmp.Free;
    end;
    ADefaultDraw := False;
  end;
  {$ENDIF}
  inherited;
end;

procedure TTMSFNCWXCustomThumbnailList.DoGenerateThumbnail(Sender: TObject;
  NumPage: Integer; Base64Img: string);
var
  itm: TTMSFNCWXThumbnailListItem;
  {$IFNDEF WEBLIB}
  p: Integer;
  strm: TBytesStream;
  base: string;
  {$ENDIF}
begin
  if Assigned(FOldNotification) then
    FOldNotification(Self, NumPage, Base64Img);

  itm := (Items[NumPage - 1] as TTMSFNCWXThumbnailListItem);
  {$IFNDEF WEBLIB}
  base := Base64Img;
  p := Pos(',', base);
  if p > 0 then
  begin
    Delete(base, 1, p);
    strm := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(base));
    try
      itm.Bitmap := TTMSFNCBitmap.CreateFromStream(strm);
    finally
      strm.Free;
    end;
  end;
  {$ENDIF}
  {$IFDEF WEBLIB}
  itm.Bitmap := TTMSFNCBitmap.Create;
  itm.Bitmap.URL := Base64Img;
  {$ENDIF}
end;

procedure TTMSFNCWXCustomThumbnailList.DoItemDrawContent(
  AGraphics: TTMSFNCGraphics; ARecT: TRectF; AItem: TTMSFNCCustomListItem);
begin
  inherited;
  if Assigned((AItem as TTMSFNCWXThumbnailListItem).Bitmap) then
    AGraphics.DrawBitmap(ARect,(AItem as TTMSFNCWXThumbnailListItem).Bitmap);
end;

procedure TTMSFNCWXCustomThumbnailList.DoItemSelected(AItemIndex: Integer);
begin
  if Assigned(Viewer) then
  begin
    if (AItemIndex >= 0) and (AItemIndex <= Items.Count - 1) then
    begin
      Viewer.ShowPage(AItemIndex + 1);
    end;
  end;
  inherited;
end;

procedure TTMSFNCWXCustomThumbnailList.DoPDFLoaded(Sender: TObject;
  NumPages: Integer);
begin
  if Assigned(FOldLoaded) then
    FOldLoaded(Self, NumPages);

  FNumPages := NumPages;
  Rebuild;
end;

procedure TTMSFNCWXCustomThumbnailList.DoPDFNavigatePage(Sender: TObject;
  APageNumber: Integer);
begin
  if Assigned(FOldShowPage) then
    FOldShowPage(Sender, APageNumber);

  ProcessSelection(APageNumber - 1);
end;

procedure TTMSFNCWXCustomThumbnailList.DoThumbnailProgress(Sender: TObject;
  APosition, ASize: Integer);
begin
  if APosition = ASize then
    Invalidate;
end;

function TTMSFNCWXCustomThumbnailList.GetDocURL: string;
begin
  Result := 'https://download.tmssoftware.com/doc/tmsfncwxpack/components/ttmsfncwxpdfthumbnaillist/';
end;

function TTMSFNCWXCustomThumbnailList.GetTotalContentHeight: Double;
var
  dsp: TTMSFNCCustomListDisplayItem;
begin
  Result := inherited;
  if Assigned(DisplayList) and (DisplayList.Count > 0) and (Orientation = toVertical) then
  begin
    dsp := DisplayList[DisplayList.Count - 1];
    Result := dsp.AbsRect.Bottom + Appearance.VerticalSpacing;
  end;
end;

function TTMSFNCWXCustomThumbnailList.GetTotalContentWidth: Double;
var
  dsp: TTMSFNCCustomListDisplayItem;
begin
  Result := inherited;
  if Assigned(DisplayList) and (DisplayList.Count > 0) and (Orientation = toHorizontal) then
  begin
    dsp := DisplayList[DisplayList.Count - 1];
    Result := dsp.AbsRect.Right + Appearance.HorizontalSpacing;
  end;
end;

function TTMSFNCWXCustomThumbnailList.GetVersion: String;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCWXCustomThumbnailList.Rebuild;
var
  i: Integer;
  it: TTMSFNCWXThumbnailListItem;
begin
  BeginUpdate;
  Items.Clear;

  for I := 0 to FNumPages - 1 do
  begin
    it := (Items.Add as TTMSFNCWXThumbnailListItem);
    it.Text := Format(Appearance.TextFormat, [I + 1]);
    it.VerticalTextAlign := gtaTrailing;
  end;

  if not (csDesigning in ComponentState) then
  begin
    if Orientation = toVertical then
      Rows := FNumPages
    else
      Columns := FNumPages;

    if Orientation = toVertical then
      Appearance.ItemHeight := (Width / Columns) - (Appearance.HorizontalSpacing * Columns)
    else
      Appearance.ItemWidth := (Height / Rows) - (Appearance.VerticalSpacing * Rows);
  end;

  EndUpdate;
end;

procedure TTMSFNCWXCustomThumbnailList.SetViewer(
  const Value: TTMSFNCWXPDFViewer);
begin
  if FViewer <> Value then
  begin
    FViewer := Value;
    if Assigned(Viewer) then
    begin
      Viewer.ThumbnailSize := 150;

      FOldCalculate := Viewer.CalculateThumbnails;
      Viewer.CalculateThumbnails := True;

      FOldNotification := Viewer.OnGenerateThumbnail;
      Viewer.OnGenerateThumbnail := {$IFDEF LCLLIB}@{$ENDIF}DoGenerateThumbnail;

      FOldLoaded := Viewer.OnLoaded;
      Viewer.OnLoaded := {$IFDEF LCLLIB}@{$ENDIF}DoPDFLoaded;

      FOldThumbsProgress := Viewer.OnThumbnailProgress;
      Viewer.OnThumbnailProgress := {$IFDEF LCLLIB}@{$ENDIF}DoThumbnailProgress;

      FOldShowPage := TTMSFNCWXPDFViewerOpen(Viewer).OnShowPage;
      TTMSFNCWXPDFViewerOpen(Viewer).OnShowPage := {$IFDEF LCLLIB}@{$ENDIF}DoPDFNavigatePage;
    end
    else
    begin
      FOldLoaded := nil;
      FOldNotification := nil;
      FOldThumbsProgress := nil;
    end;
  end;

  InitializeDefault;
end;

{ TTMSFNCWXPDFThumbnailList }

procedure TTMSFNCWXPDFThumbnailList.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCWXPDFThumbnailList);
end;

{ TTMSFNCWXThumbnailListItems }

function TTMSFNCWXThumbnailListItems.CreateItemClass: TCollectionItemClass;
begin
  Result := TTMSFNCWXThumbnailListItem;
end;

{ TTMSFNCWXThumbnailListItem }

destructor TTMSFNCWXThumbnailListItem.Destroy;
begin
  if Assigned(FBitmap) then
    FBitmap.Free;
  inherited;
end;

initialization
  RegisterClass(TTMSFNCWXPDFThumbnailList);

end.
